<template>
  <div class="bio_updata">
    <div class="updata_head">我要供货</div>
    <div class="comp">
      <div class="comp_head">企业信息</div>
      <div style="margin-top:20px">
        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="企业类型">
            <el-radio-group v-model="company_type">
              <el-radio label="工厂"></el-radio>
              <el-radio label="贸易商"></el-radio>
              <el-radio label="其他"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="企业名称">
            <el-input placeholder="请输入" v-model="company" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="企业联系人">
            <el-input placeholder="请输入" v-model="link_member" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input placeholder="请输入" v-model="phone" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱">
            <el-input placeholder="请输入" v-model="email" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="资质证明">
            <el-upload
              ref="upload"
              class="upload-demo"
              :auto-upload="false"
              :on-change="prove_img_file"
              :limit="1"
              action
            >
              <el-button size="small">添加图片</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="comp">
      <div class="comp_head">报价信息</div>
      <div v-for="(item,index) in product_number" :key="index">
        <div style="line-height:30px">产品{{index+1}}</div>
        <div class="product_delete" v-if="product_number.length != 1">
          <span @click="min(index)">删除</span>
        </div>
        <div style="margin-top:20px">
          <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="类型/型号">
              <el-select v-model="product_number[index].product_type" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="产品品牌">
              <el-input placeholder="请输入" v-model="product_number[index].brand" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="现货数量">
              <el-input
                placeholder="请输入"
                v-model="product_number[index].number"
                style="width:300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="数量单位">个</el-form-item>
            <el-form-item label="日排产量">
              <el-input
                placeholder="请输入"
                v-model="product_number[index].output"
                style="width:300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="单价(元)">
              <el-input placeholder="请输入" v-model="product_number[index].price" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="产品图片">
              <el-upload
                ref="upload"
                :limit="1"
                action
                :auto-upload="false"
                :on-change=" (value)=> list_img_file(index, value)"
                list-type="picture-card"
              >
                <!-- :on-success="" -->
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="产品描述">
              <el-input
                type="textarea"
                v-model="product_number[index].detail"
                :rows="6"
                style="width:300px"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="product_number[index].remark"
                :rows="6"
                style="width:300px"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="margin-left:130px">
        <el-button type="primary" @click="add" plain>+ 我还有其他产品</el-button>(最多添加50条)
      </div>
    </div>
    <div class="comp">
      <div class="comp_head">物流信息</div>
      <div style="margin-top:20px">
        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="物流方式">
            <el-radio-group v-model="shipments_type">
              <el-radio label="自提"></el-radio>
              <el-radio label="发货"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="发货时间">
            <el-date-picker
              type="date"
              value-format="timestamp"
              v-model="shipments_date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="发货地点">
            <el-row type="flex">
              <el-col :span="5">
                <el-select v-model="form.province" placeholder="请选择" @change="change1">
                  <el-option
                    v-for="(item,index) in sel1"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-select v-model="form.city" placeholder="请选择" @change="change2">
                  <el-option
                    v-for="(item,index) in sel2"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select v-model="form.area" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in sel3"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <div style="margin-left:100px">
          <el-button type="primary" @click="submit" style="width:160px">提交</el-button>
        </div>
      </div>
    </div>
    <div style="height:30px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product_number: [
        {
          brand: "",
          detail: "",
          image: "",
          number: "",
          output: "",
          price: "",
          product_type: "",
          remark: ""
        }
      ],
      company_type: "",
      company: "",
      link_member: "",
      phone: "",
      email: "",
      aptitude: "",
      shipments_type: "",
      shipments_date: "",
      list: {},
      list_image: "",
      options: [
        {
          value: "1",
          label: "医用一次性手套"
        },
        {
          value: "2",
          label: "消毒液"
        },
        {
          value: "3",
          label: "温度枪/红外温度计"
        },
        {
          value: "4",
          label: "防护工作帽"
        },
        {
          value: "5",
          label: "防护鞋套"
        },
        {
          value: "6",
          label: "医用手术衣/床单"
        },
        {
          value: "7",
          label: "民用防护服"
        },
        {
          value: "8",
          label: "医用防护服"
        },
        {
          value: "9",
          label: "医用防护面罩"
        },
        {
          value: "10",
          label: "医用防护眼镜/护目镜"
        },
        {
          value: "11",
          label: "口罩-民用"
        },
        {
          value: "12",
          label: "口罩-医用"
        }
      ],
      option: "",
      id: this.$route.query.id,
      serve: this.$store.state.serve,
      form: {},
      sel1: null,
      sel2: null,
      sel3: null,
      token: "",
      mobile: ""
    };
  },
  created() {
    this.addFn();
    this.token = this.$cookies.get("token");
    this.mobile = this.$cookies.get("user");
  },
  methods: {
    min(index) {
      this.product_number.splice(index, 1);
    },
    add() {
      this.product_number.push({
        brand: "",
        detail: "",
        image: "",
        number: "",
        output: "",
        price: "",
        product_type: "",
        remark: ""
      });
    },
    list_img_file(index, file) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let formData = new FormData();
      formData.append("img", file.raw);
      this.axios
        .post(
          "https://www.bioflin.com:83/admin/edit_upload_img",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.product_number[index].image = res.data.data;
          }
        });
    },
    prove_img_file(file) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let formData = new FormData();
      formData.append("img", file.raw);
      this.axios
        .post(
          "https://www.bioflin.com:83/admin/edit_upload_img",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.aptitude = res.data.data;
          }
        });
    },
    submit() {
      const address = this.form.province + this.form.city + this.form.area;
      let param = new FormData();
      // param.append("mobile", this.mobile);
      // param.append("token", this.token);
      param.append("id", this.id);
      param.append("company_type", this.company_type);
      param.append("company", this.company);
      param.append("link_member", this.link_member);
      param.append("phone", this.phone);
      param.append("email", this.email);
      param.append("aptitude", this.aptitude);
      param.append("supplyList", JSON.stringify(this.product_number));
      param.append("shipments_address", address);
      param.append("shipments_type", this.shipments_type);
      param.append("shipments_date", this.shipments_date / 1000);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios.post(this.serve + "/wantSupply", param, config).then(res => {
        if (res.data.status == "success") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.$router.push("/bioLook_index");
        } else if (res.data.status == "error") {
          this.$message.error(res.data.msg);
        }
      });
    },
    change2(v) {
      this.axios.get(this.serve + "/area?name=" + v).then(res => {
        this.sel3 = res.data;
      });
    },
    change1(v) {
      this.axios.get(this.serve + "/city?name=" + v).then(res => {
        this.sel2 = res.data;
      });
    },
    addFn() {
      this.axios.get(this.serve + "/province").then(res => {
        this.sel1 = res.data;
      });
    }
  }
};
</script>

<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.bio_updata {
  width: 1200px;
  margin: 0 auto;
  .updata_head {
    background: #fff;

    padding: 20px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333;
  }
  .comp {
    background: #fff;

    padding: 20px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333;
    .product_delete {
      text-align: center;
      cursor: pointer;
    }
    .product_delete :hover {
      color: #e2211c;
    }
    .comp_head {
      border-bottom: 1px solid #e8e8e8;
      line-height: 50px;
    }
  }
}
</style>
